<template lang="html">
  <div class="button">
    <div class="inside-button">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  .button {
    font-size: 1rem;
    /* position: relative; */
    border: 1.7px solid #2238FF;
    border-radius: 7px;
    /* min-width: 100px; */
    width: 270px;
    /* height: 2.875em; */
    cursor: pointer;
    padding: 0.5em 0;
    transition: .2s;
  }
  .button:hover {
    border-color: #6978FF;
  }
  .button:active {
    border-color: white;
  }
  .inside-button {
    text-align: center;
    /* position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%); */
  }
</style>
